import { render, staticRenderFns } from "./ShowMessage.vue?vue&type=template&id=48fb6704"
import script from "./ShowMessage.vue?vue&type=script&lang=js"
export * from "./ShowMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports